// extracted by mini-css-extract-plugin
export default {"title":"drink_title__wUDLB","img":"drink_img__dK7zQ"};